import copy from 'copy-to-clipboard'
import { useEffect } from 'react'

import { BOOK_BASE } from '../../../utils/constants'
import Paragraph from '../../app/design/Paragraph'
import { ConfirmationModal } from './ConfirmationModal'

type Props = {
    uri: string
    isOpen: boolean
    onClose: VoidFunction
}

export function ShareLinkModal({ uri, isOpen, onClose }: Props) {
    const shareLink = (() => {
        if (!uri) {
            return ''
        }

        let formattedUri = uri
        if (!formattedUri.startsWith('/')) {
            formattedUri = `/${formattedUri}`
        }

        return encodeURI(`${BOOK_BASE}${formattedUri}`)
        // return encodeURI(`${BOOK_BASE}/book/${username}/items/${itemURL}`)
    })()

    useEffect(() => {
        if (isOpen) {
            copy(shareLink)
        }
    }, [isOpen, shareLink])

    return (
        <ConfirmationModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={() => {
                window.open(shareLink, '_blank')
            }}
            title="Link copied to clipboard"
            cancelButtonText="Close"
            confirmButtonText="Open in new tab"
        >
            <Paragraph>
                Your booking link has been copied to your clipboard. You can now paste it anywhere
                you{"'"}d like.
            </Paragraph>
        </ConfirmationModal>
    )
}
